import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { FINISHED_GOODS_SALES_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const FinishedGoodsSalesApi = createApi({
  reducerPath: "FinishedGoodsSales",
  baseQuery,
  tagTypes: ["FinishedGoodsSales"],
  endpoints: (builder) => ({
    getFinishedGoodsSales: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: FINISHED_GOODS_SALES_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: FINISHED_GOODS_SALES_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["FinishedGoodsSales"],
    }),
    getFinishedGoodsSalesById: builder.query({
      query: ({ id }) => {
        return {
          url: `${FINISHED_GOODS_SALES_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["FinishedGoodsSales"],
    }),
    addFinishedGoodsSales: builder.mutation({
      query: (payload) => ({
        url: FINISHED_GOODS_SALES_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["FinishedGoodsSales"],
    }),
    updateFinishedGoodsSales: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${FINISHED_GOODS_SALES_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["FinishedGoodsSales"],
    }),
    deleteFinishedGoodsSales: builder.mutation({
      query: (id) => ({
        url: `${FINISHED_GOODS_SALES_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FinishedGoodsSales"],
    }),
  }),
});

export const {
  useGetFinishedGoodsSalesQuery,
  useGetFinishedGoodsSalesByIdQuery,
  useAddFinishedGoodsSalesMutation,
  useUpdateFinishedGoodsSalesMutation,
  useDeleteFinishedGoodsSalesMutation,
} = FinishedGoodsSalesApi;

export default FinishedGoodsSalesApi;
